import type { IconData } from '@stacksjs/iconify-core'

export const ps4x3: IconData = {
  "body": "<path fill=\"#009639\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M0 0h640v320H0z\"/><path d=\"M0 0h640v160H0z\"/><path fill=\"#ed2e38\" d=\"m0 0l320 240L0 480Z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ps4x3
